
















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'documents', 'sums', 'meta'
    ])
  }
})
export default class ProductMatrix extends Vue {
  @Prop({ type: [Number, String] }) clientId!: number | string;

  documents!: any[];
  sums!: any;
  meta!: any;
  loading!: boolean;

  public period: Date = moment().startOf('month').toDate();
  public exporting = false;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.reload();
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    this.$store.unregisterModule(STORE_KEY);
  }

  get tableRows() {
    const rows = this.documents.map((row: any) => ({ ...row, isTotal: false }));

    if (rows.length > 0 && this.sums) {
      rows.push({
        isTotal: true,
        product_name: 'ИТОГО:',
        weight: this.sums.weight,
        residual_total: this.sums.residual_total
      });
    }

    return rows;
  }

  rowClass(row: any) {
    return row && row.isTotal ? 'product-matrix-total' : '';
  }

  reload() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      clientId: this.clientId,
      period: this.period
    });
  }

  exportData() {
    this.exporting = true;

    this.$store.dispatch(`${STORE_KEY}/exportDataAsXLSX`, {
      clientId: this.clientId,
      period: this.period
    }).finally(() => {
      this.exporting = false;
    });
  }
}
